<template>
  <div class="form-bg">
    <div class="form-bg-img">
      <div class="form-container">
        <h1 class="form-title">メール配信停止</h1>
        <div v-if="!isSystemError" class="form-description">
          配信を解除するメールアドレスをご確認のうえ、「停止」ボタンを押下してください。
        </div>
        <!-- <form method="post"> -->
        <div class="form-content-inner">
          <div
            v-if="!isSystemError"
            id="formGroupDiv"
            class="form-group"
            :class="{ 'has-tooltip': isTruncated }"
            :data-tooltip="displayEmail"
          >
            <div
              ref="emailEl"
              class="form-email"
              @mouseenter="checkTruncated"
            >{{ displayEmail }}</div>
          </div>
          <div>
            <div v-if="isSystemError" class="error-block">
              <ul>
                <li>システムエラーが発生しました</li>
              </ul>
            </div>
          </div>
          <div v-if="!isSystemError" class="form-btn-wrap">
            <button
              :disabled="!canSubmit"
              class="btn btn-primary"
              @click="onSubmit()"
            >
              停止
            </button>
          </div>
        </div>
        <!-- </form> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Optout',

  data() {
    return {
      email: '',
      encrypted: '',
      processing: false,
      loading: true,
      apiUrl: process.env.LAMDA_ENDPOINT,
      isSystemError: false,
      isTruncated: false,
    }
  },

  computed: {
    /** @type {boolean} 停止ボタンを押下できるかどうか */
    canSubmit() {
      return !!this.email && !this.processing && !this.loading
    },
    /** @type {string} 表示用メールアドレス（読み込み中はプレースホルダ） */
    displayEmail() {
      return this.loading ? '読み込み中...' : this.email
    },
    /** @type {string} 配信停止リクエストの POST パラメータ（JSON 文字列） */
    postParam() {
      return JSON.stringify({
        email: this.email,
        encrypted: this.encrypted,
      })
    },
    /** @type {string} メールアドレス取得リクエストの POST パラメータ（JSON 文字列） */
    getEmailParam() {
      return JSON.stringify({
        encrypted: this.encrypted,
        action: 'getEmail',
      })
    },
  },

  created() {
    this.encrypted = this.$route.query.bdop
    this.fetchEmail()
  },

  methods: {
    /**
     * メールアドレスが省略表示（…）されているか判定し、
     * 省略時のみツールチップを表示する
     */
    checkTruncated() {
      const el = this.$refs.emailEl
      this.isTruncated = !!el && el.scrollWidth > el.clientWidth
    },
    /**
     * 復号済みメールアドレスを取得し、表示用に保持する
     */
    fetchEmail() {
      this.loading = true
      this.isSystemError = false
      axios
        .post(this.apiUrl, this.getEmailParam, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {
          if (response['data']['status'] && response['data']['email']) {
            this.email = response['data']['email']
          } else {
            this.isSystemError = true
          }
        })
        .catch((err) => {
          this.isSystemError = true
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 配信停止リクエストを送信し、成功時は完了画面へ遷移する
     */
    onSubmit() {
      this.processing = true
      this.isSystemError = false
      axios
        .post(this.apiUrl, this.postParam, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => {
          if (response['data']['status']) {
            this.$router.push('Success')
          } else {
            this.isSystemError = true
          }
        })
        .catch((err) => {
          this.isSystemError = true
          console.log(err)
        })
        .finally(() => {
          this.processing = false
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Optout.vue